import { useEffect } from "react";
import useAppStore from "src/stores/appStore";
import { selectedAssistantSelector, pageNameSelector } from "src/stores/selectors/appSelectors";
import { previewLiveBuildResponseSelector } from "src/stores/selectors/previewSelectors";
import { BUILD_STATUSES } from "@consts";
import { DONT_SHOW_AGAIN_STORAGE } from "../../header-types/status-header/DraftPublishing/DraftHeaderConsts";
import { setInfoPopoversSelector } from "src/stores/selectors/tripletsSelectors";
import { useMutatePreparePreview } from "src/queries/hooks/preview";

export const usePreparePreviewDialog = (onClose) => {
  const assistant = useAppStore(selectedAssistantSelector);
  const pageName = useAppStore(pageNameSelector);
  const previewLiveBuildResponse = useAppStore(previewLiveBuildResponseSelector);
  const setInfoPopovers = useAppStore(setInfoPopoversSelector);

  const { mutateAsync: preparePreview, isPending: isBuilding, reset: resetPreparePreview } = useMutatePreparePreview();

  useEffect(() => {
    if (previewLiveBuildResponse?.status === BUILD_STATUSES.PENDING) {
      resetPreparePreview();
    }
  }, [previewLiveBuildResponse, resetPreparePreview]);

  const handlePreparePreview = async () => {
    try {
      await preparePreview({ assistantId: assistant?.assistantId, pageName });
    } catch {
      // Error is already logged in the service
    }
  };

  const handleConfirm = () => {
    handlePreparePreview();
    onClose();
    setInfoPopovers(DONT_SHOW_AGAIN_STORAGE.PREPARE_PREVIEW, false);
  };

  return {
    isBuilding,
    handleConfirm,
    assistantName: assistant?.name,
    environment: assistant?.environment
  };
};

